import { useSearchParams, useLocation } from "react-router-dom";
import {
  doLogout,
  getFromLocalStorage,
  getPartnerLoggedInDetails,
  isPartnerAuthenticated,
  isSubUserLoggedIn,
} from "../common/utility";
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import PartnerHeader from "../components/molecules/PartnerHeader";
import store from "../redux/store";
import {
  setCartItemCountAction,
  setCommonConfigDataAction,
  setUserDetailsAction,
} from "../redux/actions/actions";
import { UserStatesAPI } from "../api/UserStatesAPI";
import { connect } from "react-redux";
import Forbidden from "../pages/Forbidden";
import { getCartDetails } from "../api/ProductsListAPI";
import { licenseMandateAPI } from "../api/GetBasicDetailsAPI";
import Env from "../Environments";
import { Paths } from "../Routes/path";
import TrainingToolTip from "../components/molecules/TrainingToolTip";
import { getCommonConfig } from "../api/CommonAPI";
import LicenseMandate from "../components/organisms/LicenseMandate";

const Partner = ({ children, forbidden, user, subUserAllowed }) => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const redirectSource = searchParams.get("redirectSource");
  const { dispatch } = store;
  const { lcoAdminId } = user || {};
  const [userNotAllowed, setUserNotAllowed] = useState(false);
  const loggedInUser = getPartnerLoggedInDetails();
  const [mandate, setMandate] = useState(null);
  const isSubUser = isSubUserLoggedIn();
  const fetchCommonConfig = async () => {
    const { data } = await getCommonConfig();
    data && dispatch(setCommonConfigDataAction(data));
  };

  const fetchCartDetails = async () => {
    const response = await getCartDetails();
    if (response && response.result) {
      const { itemAndPaymentSummariesReq } = response.result;
      const data = {
        existingCartItemCount: itemAndPaymentSummariesReq.length,
        existingCartItems: response.result,
      };
      dispatch(setCartItemCountAction(data));
    } else {
      const cart_products = getFromLocalStorage("LCO", "_Cart_Products") || {};
      const cart_products_data =
        (cart_products.data && cart_products.data) || [];
      if (cart_products_data.length) {
        const data = {
          cartItemCount: cart_products_data.length,
        };
        dispatch(setCartItemCountAction(data));
      }
    }
  };

  const getUserDetails = async () => {
    const data = await UserStatesAPI();
    if (data && data.result) {
      const { onboardingCompleted } = data.result;
      if (onboardingCompleted) {
        fetchCartDetails();
      }
      dispatch(setUserDetailsAction(data.result));
    }
  };

  const getLicenseData = async () => {
    if (
      window &&
      window.location.pathname &&
      window.location.pathname.includes("/partner/add/license")
    ) {
      getUserDetails();
    } else {
      const data = await licenseMandateAPI();
      setMandate(data);
      setUserNotAllowed(data && data.blocked);
      if (!data.blocked) {
        getUserDetails();
      }
    }
  };

  useEffect(() => {
    !loggedInUser.UUID &&
      lcoAdminId &&
      Env.getGoogleAnalyticsEnabled() &&
      ReactGA.initialize(Env.getPartnerGAMeasurementId(), {
        gaOptions: {
          userId: lcoAdminId,
          name: user.user.firstName + " " + user.user.lastName,
          lcoAdminId,
        },
      });
    // eslint-disable-next-line
  }, [lcoAdminId]);

  useEffect(() => {
    const page = Object.values(Paths).find((item) =>
      item.path.includes(pathname)
    );
    page && page.type !== "tabs" && (document.title = page.title);
  }, [pathname]);

  useEffect(() => {
    !isPartnerAuthenticated() && doLogout();
    if (isPartnerAuthenticated()) {
      getLicenseData();
      fetchCommonConfig();
    }
    // eslint-disable-next-line
  }, []);

  if (userNotAllowed) {
    return (
      <LicenseMandate data={mandate} />
    );
  }
  if (!subUserAllowed && isSubUser) {
    return (
      <>
      </>
    )
  }
  return (
    <>
      {redirectSource !== "teams" && <PartnerHeader />}
      {!forbidden && children}
      {!forbidden && !loggedInUser.UUID && (
        <TrainingToolTip pageTitle={document.title} />
      )}
      {forbidden && <Forbidden />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    forbidden: state.forbidden,
    user: state.userDetails,
  };
};

export default connect(mapStateToProps, null)(Partner);
